export default __webpack_public_path__ + "static/media/arrowRightBlue.18ff0945.svg";